import { fetchUserInfoIfNeeded } from '@pec/aion-ui-core/actions/userInfo';
import * as React from 'react';
import { CommonRootState } from '@pec/aion-ui-core/combineReducers';
import { connect } from 'react-redux';
import { fetchServerTokensIfNeeded } from '@pec/aion-ui-core/actions/serverTokens';
import { FooterComponent } from '../components/Footer';
import { RootActions } from '@pec/aion-ui-core/combineActions';
import { ThunkDispatch } from 'redux-thunk';
import { PECEnv, traceHeaderName } from '@pec/aion-ui-core/interfaces/serverTokens';

type OwnProps = {
  typography?: string;
  showLanguageSwitcher?: boolean;
};

const mapStateToProps = (state: CommonRootState) => ({
  serverTokens: state.serverTokens.serverTokens,
  userInfo: state.userInfo.userInfo
});

const mapDispatchToProps = (dispatch: ThunkDispatch<CommonRootState, null, RootActions>) => ({
  fetchServerTokensIfNeeded: () => dispatch(fetchServerTokensIfNeeded()),
  fetchUserInfoIfNeeded: () => dispatch(fetchUserInfoIfNeeded())
});

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & OwnProps;

const { production } = PECEnv;

const url = document.createElement('script');
const chat = document.createElement('script');
chat.id = 'chat';
url.id = 'url';
url.type = 'text/javascript';
url.src = 'https://service.force.com/embeddedservice/5.0/esw.min.js';
chat.type = 'text/javascript';
chat.innerHTML = `
    let NF_ENV = "UAT"
    const NF_DOMAIN = "pecdata.com"
`;

const appendScripts = (state: Props) => {
  if (state.serverTokens?.pecEnv === production) {
    chat.innerHTML =
      chat.innerHTML +
      `
      NF_ENV = "PROD"
      var communityUrl = "https://pecsafety.my.salesforce-sites.com/test";
      const script=document.createElement('script');script.src=communityUrl+'/resource/LiveChatSnippet'+'?t='+Date.now();document.head.appendChild(script);
      var userContext = {
        FirstName: '',
        LastName: '',
        Email: '',
        PreferredLanguage: '',
        Product: '',
        AccountId: ''
      };`;
  } else {
    chat.innerHTML =
      chat.innerHTML +
      `
      var communityUrl = "https://pecsafety--uat.sandbox.my.salesforce-sites.com/test";
      const script=document.createElement('script');script.src=communityUrl+'/resource/LiveChatSnippet'+'?t='+Date.now();document.head.appendChild(script);
      var userContext = {
        FirstName: '',
        LastName: '',
        Email: '',
        PreferredLanguage: '',
        Product: '',
        AccountId: ''
      };`;
  }
  document.body.appendChild(url);
  document.body.appendChild(chat);
};

class FooterContainer extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    fetchServerTokensIfNeeded();
    fetchUserInfoIfNeeded();
  }

  componentDidMount() {
    appendScripts(this.props);
  }

  componentWillUnmount() {
    if (chat) {
      chat.remove();
    }
    if (url) {
      url.remove();
    }
  }

  render() {
    const { serverTokens, userInfo, typography, showLanguageSwitcher } = this.props;
    const traceHeaderValue =
      serverTokens && serverTokens[traceHeaderName] !== 'undefined' ? serverTokens[traceHeaderName] : null;

    return (
      <FooterComponent
        traceHeaderValue={traceHeaderValue}
        typography={typography}
        showLanguageSwitcher={showLanguageSwitcher}
        userId={userInfo?.userId}
      />
    );
  }
}

export const Footer = connect(mapStateToProps, mapDispatchToProps)(FooterContainer);
